module.exports = __webpack_public_path__ + "img/Evaluation_Recommendation_SouthKorea.d35b15a6.png";